export default "/images/e049da49eb7a735c72ed39907b84f975.avif";